import { type OpenShift } from "@clipboard-health/contract-worker-app-bff";
import { useMemo } from "react";

import { groupShiftsIntoDoubles } from "./groupShiftsIntoDoubles";
import type { ShiftDouble } from "./types";
import { useShiftDoublesEnabled } from "./useShiftDoublesEnabled";

export function useShiftDoubles(shifts: OpenShift[]): Map<string, ShiftDouble> {
  const enabled = useShiftDoublesEnabled();

  return useMemo(() => {
    if (!enabled) {
      return new Map<string, ShiftDouble>();
    }

    return groupShiftsIntoDoubles(shifts);
  }, [enabled, shifts]);
}
